import React from "react";

// Native, always-clickable pagination. Replaces react-js-pagination (v3, 2019),
// whose page clicks did not reliably fire under React 18. Works for both server
// tables (setPage triggers a refetch) and client tables (setPage re-slices).
const Pagination = (props) => {
  const {
    type,
    setPage,
    setActivePage,
    userTotal,
    rowsPerPage,
    activePage,
    // client props
    size,
    totalData,
  } = props;

  const total = type === "client" ? Number(totalData ?? 0) : Number(userTotal ?? 0);
  const perPage = Number((type === "client" ? size : rowsPerPage) || rowsPerPage || 10);
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const current = Math.min(Math.max(1, Number(activePage) || 1), totalPages);

  const goTo = (n) => {
    const p = Math.min(Math.max(1, n), totalPages);
    if (p === current) return;
    if (typeof setPage === "function") setPage(p);
    else if (typeof setActivePage === "function") setActivePage(p);
  };

  if (!total || total <= 0) return null;

  // windowed page numbers around the current page
  const windowSize = 3;
  let start = Math.max(1, current - 1);
  let end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);

  const item = (key, label, target, { disabled = false, active = false } = {}) => (
    <li key={key} className={`page-item ${active ? "active" : ""} ${disabled ? "disabled" : ""}`}>
      <button
        type="button"
        className="page-link"
        disabled={disabled}
        onClick={() => goTo(target)}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        {label}
      </button>
    </li>
  );

  return (
    <div className="row gx-0 custom-pagination m-0 w-100 px-3">
      <div className="col-12 d-flex justify-content-between align-items-center flex-wrap mt-3 mb-3">
        <p style={{ marginBottom: 0, fontSize: "15px", fontWeight: 500 }}>
          Showing {current} out of {totalPages} pages
        </p>
        <ul
          className="pagination mb-0"
          style={{ display: "flex", flexWrap: "wrap", gap: "4px", listStyle: "none", margin: 0, padding: 0 }}
        >
          {item("first", "«", 1, { disabled: current === 1 })}
          {item("prev", "‹", current - 1, { disabled: current === 1 })}
          {start > 1 && item("p1", "1", 1)}
          {start > 2 && (
            <li key="lgap" className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          )}
          {pages.map((p) => item(`p${p}`, String(p), p, { active: p === current }))}
          {end < totalPages - 1 && (
            <li key="rgap" className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          )}
          {end < totalPages && item("plast", String(totalPages), totalPages)}
          {item("next", "›", current + 1, { disabled: current === totalPages })}
          {item("last", "»", totalPages, { disabled: current === totalPages })}
        </ul>
      </div>
    </div>
  );
};

export default Pagination;
